<template>
  <header class="header" id="header">
    <div class="friendly-link">
      <div class="main">
        <span class="intro">六一教育旗下品牌：</span>
        <a
          href="http://www.61draw.com/#/home"
          target="_blank"
          class="draw"
          title="画啦啦少儿美术"
          data-element-content="画啦啦少儿美术"
          @click="handleFriendlyLinkClick"
          >画啦啦少儿美术</a
        >
        <a
          href="http://www.dengta.61draw.com/pcLogin.html"
          target="_blank"
          class="dengta"
          title="画啦啦小灯塔"
          data-element-content="画啦啦小灯塔"
          @click="handleFriendlyLinkClick"
          >画啦啦小灯塔</a
        >
      </div>
    </div>
    <div class="nav">
      <div class="main clearfix">
        <div class="logo"></div>
        <div class="nav-content" :class="navActiveClassName">
          <div class="nav-item">
            <router-link
              to="/"
              @click.native="handleNavClick"
              data-element-content="首页"
              >首页</router-link
            >
          </div>
          <div class="nav-item">
            <router-link
              to="/course"
              @click.native="handleNavClick"
              :data-element-content="isAd ? '报名上课' : '课程体系'"
              >{{ isAd ? '报名上课' : '课程体系' }}</router-link
            >
          </div>
          <div class="nav-item">
            <router-link
              to="/download"
              @click.native="handleNavClick"
              data-element-content="下载中心"
              >下载中心</router-link
            >
          </div>
          <div class="slide" v-if="navActiveClassName"></div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { isAd, convertRouteNameToTitle } from '../../util'
export default {
  name: 'Header',
  data() {
    return {
      navActiveClassName: '',
      isAd: isAd(),
    }
  },
  async created() {
    if (this.$route.name) {
      this.navActiveClassName = this.$route.name.toLowerCase() + '-active'
    }
    if (isAd) {
      const { default: sensors } = await import('sa-sdk-javascript')
      this.sensors = sensors
    }
  },
  watch: {
    $route(to) {
      this.navActiveClassName = to.name.toLowerCase() + '-active'
    },
  },
  methods: {
    sendSensors(content) {
      if (isAd) {
        // 若果是推广页，则需要上报神策
        this.sensors.track('$WebClick', {
          $title: convertRouteNameToTitle(this.$route.name),
          $element_content: content,
        })
      }
    },
    handleNavClick(e) {
      // 是当前路由，则回到顶部
      if (this.$route.path === window.location.hash.replace('#', '')) {
        window.scrollTo({ top: 0, left: 0 })
      }
      this.sendSensors(e.target.dataset.elementContent)
    },
    handleFriendlyLinkClick(e) {
      this.sendSensors(e.target.dataset.elementContent)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
